import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6,11L1,6l5-5"
    />
  </svg>
);

const IconChevronLeft: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconChevronLeft;
